import Spacer from '@eduact/ed-components/Spacer'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { useGetAllInstructorsQuery } from '@Features/Instructor/InstructorApi/Instructor.api'
import React from 'react'
import Categories from '../Components/Categories'
import InstructorsCarousel from '../Components/InstructorsCarousel'
import NewsFeedsSection from '../Components/NewsFeedsSection/NewsFeedsSection'
import TrustStats from '../CustomLanding/Components/TrustStats'
import ExamsSection from './Components/ExamsSection/ExamsSection'
import MyClassroomsSection from './Components/MyClassroomsSection/MyClassroomsSection'
import MyCoursesSection from './Components/MyCoursesSection'
import OnlineClassroomsSection from './Components/OnlineClassroomsSection/OnlineClassroomsSection'
import RevisionsSection from './Components/RevisionsSection/RevisionsSection'
import FeaturedCoursesCarousel from '../Components/FeaturedCoursesCarousel'
import FeaturedBundlesCarousel from '../Components/FeaturedBundlesCarousel'
import { StudentLandingPageWrapper } from './StudentLanding.styled'

type Props = {}

const StudentLanding: React.FC<Props> = () => {
	const { instructor_section, subjects_section, classrooms_enabled } = useAppSelector(s => s.settings)
	/* Same cache entry the carousel reads — no extra request. The gate keeps
	   the Spacer from surviving as an empty padding band on desktop when the
	   carousel renders null (no instructors at all). */
	const { data: instructors, isLoading: instructorsLoading } = useGetAllInstructorsQuery(undefined, { skip: !instructor_section })
	return (
		<StudentLandingPageWrapper>
			<NewsFeedsSection />
			{instructor_section && (instructorsLoading || (instructors?.data.length ?? 0) > 0) && (
				<Spacer py={{ lg: '1.625rem' }}>
					<InstructorsCarousel />
				</Spacer>
			)}
			<Spacer px={{ lg: '3.125rem' }}>
				<MyCoursesSection />
				{classrooms_enabled && <MyClassroomsSection />}
				{classrooms_enabled && <OnlineClassroomsSection />}
				{classrooms_enabled && <ExamsSection />}
				{classrooms_enabled && <RevisionsSection />}
			</Spacer>
			<Spacer py={{ lg: '1.625rem' }}>
				<FeaturedCoursesCarousel />
				<FeaturedBundlesCarousel />
			</Spacer>
			{subjects_section && (
				<Spacer mt={{ lg: '12.5rem' }}>
					<Categories />
				</Spacer>
			)}
			{/* tenant/mribrahimfarid: the platform's growth counters (classrooms /
			    instructors / enrollments, all zero here) are replaced by the
			    landing page's experience band. */}
			<TrustStats />
		</StudentLandingPageWrapper>
	)
}

export default StudentLanding
